import Vue from 'vue'
import errorHandling from './exceptions'
import { USERS, USER_GROUPS } from '@/api'

// Retorna todos os usuários cadastrados
const index = (params, callback) => {
  Vue.axios.get(USERS, { params })
    .then(res => {
      if (typeof res.data.meta !== 'undefined') {
        callback(res.data.users, res.data.meta.pagination)
      } else {
        callback(res.data.users)
      }
    })
    .catch(errorHandling)
}

// Cria um novo usuário
const store = (data, callback, errorCallback) => {
  Vue.axios.post(USERS, data)
    .then(callback)
    .catch(errorCallback)
}

// Retorna os dados de um usuário
const show = (id, callback) => {
  Vue.axios.get(USERS + '/' + id)
    .then(res => {
      callback(res.data)
    })
    .catch(errorHandling)
}

// Atualiza os dados do usuário
const update = (id, data, callback, errorCallback) => {
  Vue.axios.put(USERS + '/' + id, data)
    .then(callback)
    .catch(errorCallback)
}

// Remove o usuário
const destroy = (id, callback) => {
  Vue.axios.delete(USERS + '/' + id)
    .then(callback)
    .catch(errorHandling)
}

// Retorna a lista de grupos
const fetchGroups = (callback) => {
  Vue.axios.get(USER_GROUPS)
    .then(res => {
      callback(res.data)
    })
    .catch(errorHandling)
}

export default {
  index,
  store,
  show,
  update,
  destroy,
  fetchGroups
}
